import {TalentSurvey} from '../types';

import {attribute} from '../../../lib/api/v1/talent/survey/attribute';
import {complete} from '../../../lib/api/v1/talent/survey/complete';
import {startTalentSurvey} from '../../../lib/api/v1/talent/survey/startTalentSurvey';

export class TalentService {
  static async submitTalentSurvey(talentSurvey: TalentSurvey): Promise<void> {
    try {
      const response = await complete(talentSurvey);

      if (response.ok) {
        return Promise.resolve();
      }
    } catch (error: unknown) {
      console.error(error);
      throw error;
    }
  }

  static async attributeTalentSurvey(talentSurveyId: string, applicantId: string): Promise<void> {
    try {
      if (talentSurveyId) {
        const response = await attribute(talentSurveyId, applicantId);

        if (response.ok) {
          return Promise.resolve();
        }
      }
    } catch (error: unknown) {
      console.error(error);
      throw error;
    }
  }

  static async startTalentSurvey(talentSurvey: TalentSurvey): Promise<void> {
    try {
      const response = await startTalentSurvey(talentSurvey);

      if (response.ok) {
        return Promise.resolve();
      }
    } catch (error: unknown) {
      console.error(error);
      throw error;
    }
  }
}
